import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { ExchangeProtectionDataProviderFactory } from '../factory/ExchangeProtectionDataProviderFactory';
import { ExchangeProtectionDataProvider } from '../dataProvider/ExchangeProtectionDataProvider';
import { ExchangeProtectionWebComponentSchema } from '../types';

export class ExchangeProtectionRepository extends BaseWebComponentRepository {
  public dataProviderFactory: ExchangeProtectionDataProviderFactory;
  public dataProvider: ExchangeProtectionDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new ExchangeProtectionDataProviderFactory(),
    });
  }

  public async getDataForView() {
    return this.dataProvider.getDataForView();
  }

  public async deleteSelected(query: { records: Array<any> }) {
    return this.dataProvider.deleteSelected(query);
  }

  public async restoreOriginalSelected(query: { records: Array<any> }) {
    return this.dataProvider.restoreOriginalSelected(query);
  }

  public async emptyQuarantine(query) {
    return this.dataProvider.emptyQuarantine(query);
  }

  public async saveSelected(query) {
    return this.dataProvider.saveSelected(query);
  }
}
